import { Icon } from '@components/ui/Icon/Icon';
import DownloadIcon from '@mui/icons-material/Download';
import { useTranslation } from 'react-i18next';
import { useDpoTaskFileDownloadUrlQuery } from '@dieterApi/dpo/useDpoTaskFileDownloadUrlQuery';
import { useState } from 'react';

interface UploadedDocumentDownloadBarProps {
  taskId: string;
  companyId: string;
  hasFile: boolean;
  documentName?: string;
}

export function UploadedDocumentDownloadBar({ taskId, companyId, hasFile, documentName }: UploadedDocumentDownloadBarProps) {
  const { t } = useTranslation();
  const [downloading, setDownloading] = useState(false);
  const [getDownloadUrl] = useDpoTaskFileDownloadUrlQuery();

  const handleDownload = async () => {
    console.log('Download button clicked', { taskId, companyId, hasFile, documentName });

    if (!hasFile) {
      console.error('No file available');
      return;
    }

    setDownloading(true);
    try {
      const { data } = await getDownloadUrl({
        variables: { taskId, companyId },
      });

      if (data?.getDpoTaskFileDownloadUrl) {
        console.log('Opening download URL:', data.getDpoTaskFileDownloadUrl);
        window.open(data.getDpoTaskFileDownloadUrl, '_blank', 'noopener,noreferrer');
      } else {
        console.error('No download URL returned');
      }
    } catch (error) {
      console.error('Error getting download URL:', error);
    } finally {
      setDownloading(false);
    }
  };

  return (
    <div className="bg-gray-300 w-full py-2 px-6 flex items-center justify-start">
      <button
        onClick={handleDownload}
        disabled={!hasFile || downloading}
        className="flex items-center gap-2 text-primary-root hover:text-primary-800 underline transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        data-testid="download-uploaded-document-button"
      >
        <DownloadIcon fontSize="small" />
        <span>{downloading ? t('common.downloading', 'Downloading...') : t('common.download', 'Download')}</span>
      </button>
    </div>
  );
}
